module.exports = __webpack_public_path__ + "images/7ed7c6c278a06c0fe2d75c4e7b0f8d76-ArrowGif_136x126.gif";